<template>
  <div>
    <navMenu />

    <hero :heroTitle="$t('nav.privateSchoolsBtn')" class="pb-0"/>

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 col-md-12 text-center">
            <p class="mt-4 mb-5">{{ $t("privateSchoolsPage.subtitle") }}</p>
            <schoolsCtaBtns />
          </div>
          
        </div>
      </div>
    </section>

    <modules />

    <cta :ctaText="$t('cta.privateSchools')" :ctaBtn="$t('privateSchoolsPage.offerBtn')" :ctaRoute="'/private-schools#offer'"/>
  
    <benefitsSchools />
    <requestOfferForm />
    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import schoolsCtaBtns from "./../components/schoolsCtaBtns.vue";
import benefitsSchools from "./../components/benefitsSchools.vue";
import modules from "./../components/modules.vue";
import cta from "./../components/cta.vue";
import hero from "./../components/hero.vue";
import featured from "./../components/featured.vue";
import requestOfferForm from "./../components/requestOfferForm.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "PrivateSchools",
  components: {
    navMenu,
    schoolsCtaBtns,
    benefitsSchools,
    modules,
    cta,
    featured,
    hero,
    requestOfferForm,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
